import { observer } from 'mobx-react'
import React, { FC, useEffect } from 'react'

import { SidePanelStore, SidePanelType } from '@new/__global/stores/SidePanelStore'
import { arrivalsChecklistStore } from '@new/domains/fastBookingsTapeChart/components/ExtendedColumns/components/ArrivalsChecklistSidePanel/ArrivalsChecklistStore'

import { ColorsConfig } from '../../config/colors'
import { storeHolder } from '../../stores/TapeChartStore'
import * as S from './ExtendedColumns.styles'

interface ExtendedColumnsProps {
  colorsConfig: ColorsConfig
  selected?: boolean
  even: boolean
  listItemId: string
}

const _ExtendedColumns: FC<ExtendedColumnsProps> = ({
  colorsConfig,
  selected,
  even,
  listItemId,
}) => {
  const rootStore = storeHolder.store
  const { activeColumns, setHoverBookingById, extendedColumnsWidth } =
    rootStore.extendedColumnsStore
  const { arrivalsMode } = rootStore.filterStore
  const { listingsExtendedInfo } = rootStore.stateStore
  const arrivalsChecklistSelectedHomeId =
    arrivalsChecklistStore.selectedArrivalChecklistHomeId.get()

  useEffect(() => {
    if (arrivalsChecklistSelectedHomeId) {
      SidePanelStore.setCurrentSidePanel(SidePanelType.arrivalsChecklist, {
        screenHasSecondaryMenu: true,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const currentListing = listingsExtendedInfo?.find(listing => listing.id === listItemId)

  const handleMouseEnter = () => {
    const bookingId = currentListing?.operationTags?.currentBookingId
    if (arrivalsMode && bookingId) {
      setHoverBookingById?.(bookingId)
    }
  }

  const handleMouseOut = () => {
    if (arrivalsMode) {
      setHoverBookingById?.(undefined)
    }
  }

  return activeColumns && activeColumns.length > 0 ? (
    <S.ExtendedColumnsWrapper
      even={even}
      colorsConfig={colorsConfig}
      selected={selected}
      width={extendedColumnsWidth}
      onMouseOver={handleMouseEnter}
      onMouseLeave={handleMouseOut}
    >
      {activeColumns.map(column => column.renderer(currentListing))}
    </S.ExtendedColumnsWrapper>
  ) : null
}

export const ExtendedColumns = observer(_ExtendedColumns)
